import { createContext, useEffect, useContext, useState } from "react";
import axios from "axios";
import { useUser } from ".";
import { Subscription } from "@aika/types";

const SubscriptionContext =
  createContext<
    [Subscription | null, React.Dispatch<React.SetStateAction<Subscription>>]
  >(null);

export const SubscriptionProvider = ({ children }) => {
  const [subscription, setSubscription] = useState<Subscription | null>(null);
  const { user } = useUser();

  useEffect(() => {
    if (user != null && subscription == null) {
      axios.get("/api/subscription").then(({ data }) => {
        setSubscription(data);
      });
    } else if (user == null && subscription != null) {
      setSubscription(null);
    }
  }, [user, subscription]);

  useEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error.response?.status === 402) {
          setSubscription({
            type: "expired",
          });
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptorId);
  }, [setSubscription]);

  const loading = user != null && subscription == null;

  return (
    <SubscriptionContext.Provider value={[subscription, setSubscription]}>
      {loading ? null : children}
    </SubscriptionContext.Provider>
  );
};

export const useSubscription = () => useContext(SubscriptionContext);
